/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import App from 'apmui/App';
import bind from 'apmui/decorators/bind';
import * as React from 'react';
import { IFormConfiguration } from './Model';
import Input from './Input';
import Submit from './Submit';

const app = App.get();

export default class FormView extends React.Component<IFormConfiguration> {
    static defaultProps: Partial<IFormConfiguration> = {
        fields: [],
        method: 'POST',
    };

    @bind
    onSubmit(event: Event | React.SyntheticEvent<HTMLFormElement>) {
        /* Do not submit form until validation is passed */
        event.preventDefault();
        if (!this.props.submitDisabled) {
            app.submitForm(this.props.id);
        }
    }

    @bind
    onFieldChange(name: string, value: string | boolean, event?: Event) {
        app.updateFormField(this.props.id, name, value);
    }

    render() {
        const fields = this.props.fields
            .filter((x) => x.type !== 'none')
            .map((entry, idx) => <Input key={'input_' + entry.name} onChange={this.onFieldChange} {...entry} />);

        let submit;
        if (this.props.submitCaption) {
            const submitDisabled = Boolean(this.props.submitDisabled);
            submit = <Submit caption={this.props.submitCaption} disabled={submitDisabled} />;
        }

        return (
            <form
                autoComplete="off"
                className="apmui-form"
                id={this.props.id}
                method={this.props.method}
                onSubmit={this.onSubmit}>
                {fields}
                {this.props.children}
                {submit}
            </form>
        );
    }
}
